import '@/javascript/application'

import router from '@vuejs/router'
import UnsecuredApp from '@vuejs/views/unsecured/index'

import { createVueApp } from './createVueApp'

const app = createVueApp(UnsecuredApp)

app.use(router)
app.mount('#newFrontendUnsecured')
